const TEST_GRAPHQL_ENDPOINT = 'https://test-core.allkort.com/graphql/';
const PROD_GRAPHQL_ENDPOINT = 'https://core.allkort.com/graphql/';
const LOCAL_PROXY_GRAPHQL_ENDPOINT = '/graphql';

const getFallbackEndpoint = (): string => {
  const hostname = window.location.hostname.toLowerCase();

  const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1';
  const isStagingLikeHost =
    hostname.includes('staging') ||
    hostname.includes('stage') ||
    hostname.includes('test');

  if (isLocalHost) {
    return LOCAL_PROXY_GRAPHQL_ENDPOINT;
  }

  if (isStagingLikeHost) {
    return TEST_GRAPHQL_ENDPOINT;
  }

  return PROD_GRAPHQL_ENDPOINT;
};

export const GRAPHQL_ENDPOINT =
  import.meta.env.VITE_GRAPHQL_ENDPOINT?.trim() || getFallbackEndpoint();
